import React from "react";
import { useParams } from "react-router-dom";

import {
  ModuleDetails,
  Timeline,
  CommentView,
  Loading,
  ImageGrid,
} from "@components";
import { useGetModule, useGetStepsByModule } from "@hooks";
import { Layout } from "./PageLayouts";

export function ModulePage() {
  const { moduleId } = useParams();
  const [moduleData] = useGetModule(moduleId ? moduleId : "");
  const { documents: stepData } = useGetStepsByModule(moduleId ? moduleId : "");
  return (
    <Layout>
      {moduleData && stepData ? (
        <>
          <ModuleDetails dbModule={moduleData} mysteps={stepData} />
          <CommentView steps={stepData} {...{ marginTop: "8px" }} />
          <ImageGrid images={moduleData.images} />
          <Timeline steps={stepData} item="module" />
        </>
      ) : (
        <Loading />
      )}
    </Layout>
  );
}
